module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_7.b9d1db16.png";